"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const graphql_tag_1 = tslib_1.__importDefault(require("graphql-tag"));
const featureFlagsDetailData_1 = require("./featureFlagsDetailData");
exports.basicUserDetailData = graphql_tag_1.default `
  fragment basicUserDetailData on User {
    id
    email
    fullName
    isAppAdmin
  }
`;
exports.currentUserDetailData = graphql_tag_1.default `
  fragment currentUserDetailData on User {
    ...basicUserDetailData
    featureFlagOverrides {
      ...featureFlagsDetailData
    }
    workspaceMemberships {
      id
      isWorkspaceAdmin
      workspace {
        id
        name
        isWorkspaceAnalyticsEnabled
        enableSubscriberTools
      }
    }
    currentWorkspaceMembership {
      id
      isWorkspaceAdmin
      workspace {
        id
        name
        enabledIntegrationClasses
        isWorkspaceAnalyticsEnabled
        enableSubscriberTools
        helpLink
        featureFlagOverrides {
          ...featureFlagsDetailData
        }
      }
    }
  }
  ${featureFlagsDetailData_1.featureFlagsDetailData}
  ${exports.basicUserDetailData}
`;
//# sourceMappingURL=users.js.map